import * as pages from '../components';
import * as layouts from '../components/Layouts';

export const Layouts = {
    main: layouts.Main,
    club: layouts.Club,
    plain: layouts.Plain,
    onlyFooter: layouts.OnlyFooter
};

export const Pages = {
    home: pages.Home,
    profile: pages.Profile,
    shop: pages.Shop,
    career: pages.Career,
    leaderBoard: pages.LeaderBoard,
    leaderBoardInfo: pages.LeaderBoardInfo,
    leaderBoardHints: pages.LeaderBoardHints,
    leaderBoardRewards: pages.LeaderBoardRewards,
    settings: pages.ProfileSettings,
    editProfile: pages.EditProfile,
    profileSettings: pages.ProfileSettings,
    linkEmail: pages.LinkEmail,
    changePassword: pages.ChangePassword,
    accountLevel: pages.AccountLevel,
    language: pages.Language,
    tutorial: pages.Tutorial,
    support: pages.Support,
    about: pages.About,
    league: pages.League,
    club: pages.ClubMain,
    clubSettings: pages.ClubSettings,
    clubNewMessage: pages.ClubNewMessage,
    clubMembers: pages.ClubMembers,
    clubMemberDetails: pages.MemberDetails,
    clubBuyLevel: pages.ClubBuyLevel,
    clubCounter: pages.ClubCounter,
    tradeRecord: pages.TradeRecord,
    transfer: pages.Transfer,
    clubData: pages.ClubData,
    signIn: pages.SignIn,
    autoLogin: pages.AutoLogin,
    signUp: pages.SignUp,
    messages: pages.Messages,
    message: pages.Message,
    passwordRecovery: pages.PasswordRecovery,
    createTable: pages.CreateTable,
    tableParams: pages.TableParams,
    unionMenu: pages.UnionMain,
    unionEdit: pages.UnionEdit,
    agentMenu: pages.AgentMenu,
    grandCreditHistory: pages.GrandCreditHistory,
    unionClubList: pages.UnionClubList,
    unionJoinRequests: pages.UnionJoinRequests,
    unionClubData: pages.UnionClubData,
    unionClubDataHelp: pages.UnionClubDataHelp,
};


